
// backend API Version
API_VERSION = "v1"

module.exports = {
    API_PROD: 'https://114.li/api/' + API_VERSION,
    API_DEV: 'https://test.114.li/api/' + API_VERSION
}
